import { render } from "./page-culture.vue?vue&type=template&id=219b14f6&scoped=true"
import script from "./page-culture.vue?vue&type=script&lang=js"
export * from "./page-culture.vue?vue&type=script&lang=js"

import "./page-culture.vue?vue&type=style&index=0&id=219b14f6&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219b14f6"]])

export default __exports__